import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PlugsConnected, Warning } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

export const useHealth = (enabled = true) => {
  const api = useApi();
  const { data } = useQuery({ queryKey: ["connection-health"], queryFn: () => api.get("/connections/health"),
    refetchOnWindowFocus: "always", refetchInterval: 5 * 60 * 1000, enabled });
  return data;
};

export const HealthNote = ({ health }) => {
  if (!health || !["needs_reconnect", "error"].includes(health.status)) return null;
  const bad = health.status === "needs_reconnect";
  return (
    <p data-testid={`health-note-${health.name.toLowerCase()}`} className={`mb-4 flex gap-2 rounded-lg border px-3 py-2 text-xs leading-relaxed ${bad ? "border-[#FF5C7A]/40 bg-[#FF5C7A]/10 text-[#FF8FA3]" : "border-[#FFB800]/40 bg-[#FFB800]/[0.07] text-[#FFD166]"}`}>
      <Warning weight="fill" size={14} className="shrink-0 mt-0.5" /> {health.reason}
    </p>
  );
};

export const ConnectionAlert = () => {
  const h = useHealth();
  if (!h?.needs_reconnect?.length) return null;
  const names = h.needs_reconnect.map((p) => h.providers[p].name);
  return (
    <div data-testid="connection-alert-banner" role="alert" className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-[#FF5C7A]/40 bg-[#FF5C7A]/10 px-4 py-3 text-sm fade-up">
      <PlugsConnected className="text-[#FF5C7A]" size={18} />
      <p className="flex-1 min-w-0">
        <span className="font-semibold text-[#FF8FA3]">{names.join(" and ")} {names.length > 1 ? "need" : "needs"} reconnecting.</span>{" "}
        Your forecast is using the last data we synced until you reconnect.
      </p>
      <Link to="/app/integrations" data-testid="connection-alert-link" className="rounded-full bg-[#FF5C7A] px-4 py-1.5 text-xs font-semibold text-[#050505] hover:bg-[#FF8FA3] transition-colors">Reconnect</Link>
    </div>
  );
};
